export const giftback = {
	giftbacks: {
		title: "Giftbacks",
		form: {
			active: "Activar giftback",
			name: "Nombre del giftback",
			namePlaceHolder: "Ingrese el nombre del giftback",
			minimumConsumptionLabel: "Valor mínimo de consumo",
			minimumConsumptionTooltip:
				"Valor que el cliente debe consumir para convertir en giftback.",
			percentageLabel: "Porcentaje del giftback",
			percentageTooltip:
				"Cuánto del valor consumido por el cliente será obsequiado al mismo.",
			expiresInLabel: "Expirar giftback en hasta",
			expiresInTooltip:
				"Cantidad máxima de días en que el cliente debe utilizar el giftback.",
			expiresInPlaceholder:
				"Seleccione la cantidad máxima de días en que el cliente debe utilizar el giftback",
			expiresAtLabel: "Período del canje",
			expiresAtTooltip: "Tiempo que el cliente tendrá para aprovechar el giftback.",
			expiresAtPlaceholder: "Seleccione el período de validez del giftback",
			placeLabel: "Locales",
			removeGiftback: "Eliminar giftback",
			selectAll: "Seleccionar todos",
			day: "día",
			days: "días",
			week: "semana",
			noValidity: "Sin validez",
		},
		tabs: {
			addNewGiftback: "Agregar nuevo giftback",
		},
	},
	giftbackList: {
		activate: "Activar",
		deleteConfirm: "¿Está seguro que desea eliminar el giftback?",
		deleteGiftback: "Eliminar giftback",
		table: {
			createdAt: "Creado en",
			expiresAt: "Finalizado en",
			expiresIn: "Período",
			giftback: "Giftback",
			messagesSent: "SMS enviados",
			places: "Locales",
			status: "Estado",
		},
		title: "Listado de giftbacks",
	},
	giftbackReport: {
		selectGiftbackLabel: "Campaña",
		selectGiftbackPlacholder: "Seleccione la(s) campaña(s)",
		table: {
			createdAt: "Creado en",
			giftback: "Campaña",
			messagesSent: "SMS enviados",
			places: "Locales",
			rescues: "Canjes",
			totalValue: "{{ currencySymbol }} en ventas",
			giftbackSent: "Total de giftbacks",
			giftbackValue: "{{ currencySymbol }} giftback canjeado",
			conversionRate: "Tasa de conversión",
		},
		title: "Informe de canjes",
		totalizers: {
			quantity: "Campañas creadas",
			totalSms: "Total de SMS creados",
			totalRescues: "Total de canjes",
			totalSales: "Total en ventas utilizando giftback",
		},
	},
	giftbackPowerBi: {
		title: "Informe de Giftback",
	},
};
